import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import CircularProgress from 'material-ui/CircularProgress';
import DateFnsUtils from '@date-io/date-fns';
import TextField  from 'material-ui/TextField';
import HelpIcon from '@mui/icons-material/Help';
import CoreTextField from '@material-ui/core/TextField';
import { RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import Button from '@material-ui/core/Button';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import SelectField  from 'material-ui/SelectField';
import MenuItem  from 'material-ui/MenuItem';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CallMadeIcon from '@material-ui/icons/CallMade';
import NarrativeDialog from './NarrativeDialog';
import UnitValidator from './UnitValidator';
import IrwinIdTextField  from './components/IrwinIdTextField';
import theme from '../../muiTheme';
import { getFieldAliasOverrides, getDependentAttributeMapping, isAcreageField, isClearableDateField } from '../../utils/incidentHelper';
import originFields from '../../defaults/PointOfOriginFields.json';

import './DetailRow.css';

//TODO: This entire thing needs to be completely overhauled
class DetailRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      narrativeDialogOpen: false,
      narrativeValue: (this.props.fieldInfo.name === originFields.report && this.props.attributes[this.props.fieldInfo.name]) ? this.props.attributes[this.props.fieldInfo.name] : '',
      calculatedAcresValue: (this.props.fieldInfo.name === originFields.calculatedAcres && this.props.attributes[this.props.fieldInfo.name]) ? this.props.attributes[this.props.fieldInfo.name] : null,
      isInvalidLocally: false
    };
  }

  componentWillReceiveProps(nextProps)
  {
    if ((nextProps.fieldInfo.name === originFields.calculatedAcres) && nextProps.attributes[nextProps.fieldInfo.name] !== this.state.calculatedAcresValue)
    {
      this.setState({
        calculatedAcresValue: nextProps.attributes[nextProps.fieldInfo.name]
      });
    }
  }

  getFieldValues = (fieldName, fieldOptions, isDependent, dependentAttribute, fieldValue) =>
  {
    //One off for Predominant Fuel Group / Predominant Fuel Model
    if (fieldName === originFields.predominantFuelGroup || fieldName === originFields.predominantFuelModel)
    {
          if (!isDependent)
          {
            return fieldOptions.map(option =>
              {
              return <MenuItem key={option.code} value={option.code} primaryText={option.code} />
            })
          }
          else
          {
            let filterValues = getDependentAttributeMapping(dependentAttribute, this.props.attributes[this.props.dependentAttribute]);

            if (filterValues.length > 0 && (!filterValues.includes(fieldValue) && fieldValue !== null))
            {
              this.props.onUpdateProp(fieldName, null);
            }

            return fieldOptions
            .filter(option => filterValues.indexOf(option.code) >= 0)
            .map(option => {
              return <MenuItem key={option.code} value={option.code} primaryText={option.code} />
            })
          }
    }


    if (!isDependent)
    {
      return fieldOptions.map(option => {
        return <MenuItem key={option.code} value={option.code} primaryText={option.name} />
      })
    }
    else
    {
      let filterValues = getDependentAttributeMapping(dependentAttribute, this.props.attributes[this.props.dependentAttribute]);

      if (filterValues.length > 0 && (!filterValues.includes(fieldValue) && fieldValue !== null))
      {
        this.props.onUpdateProp(fieldName, null);
      }

      return fieldOptions
      .filter(option => filterValues.indexOf(option.code) >= 0)
      .map(option => {
        return <MenuItem key={option.code} value={option.code} primaryText={option.name} />
      })
    }
  }

  onUnitValidated = (agency) =>
  {
      this.props.onAgencyValidated(this.props.fieldInfo.name, agency);
  }

  dropdownFieldIsNullable = (fieldName) =>
  {
    return originFields.nullableDropdownFields.includes(fieldName);
  }

  setNullValue = (event) =>
  {
    event.preventDefault();
    this.props.onUpdateProp(this.props.fieldInfo.name, null);
    this.setState({
      isInvalidLocally: false
    });
  }

  showNarrativePopup = (event) =>
  {
    event.preventDefault();
    this.setState({
      narrativeDialogOpen: true
    });
  }

  onNarrativeDialogClose = () =>
  {
    this.setState({
      narrativeDialogOpen: false
    });
  }

  render()
  {
    const isUnitIdField =  originFields.unitIdFields.includes(this.props.fieldInfo.name);

    let hasTooltip = false;
    let tooltipContent = '';

    if (isUnitIdField) 
    {
      
      const matchValue = this.props.attributes[this.props.fieldInfo.name];
      const matchedEntry = (this.props.knownUnitIds)  ? this.props.knownUnitIds.filter(function (item) 
      {
        return item.UnprefixedUnitID === matchValue;
      }) : false;

      if (matchedEntry) 
      {
        if (matchedEntry && matchedEntry.length > 0) 
        {
          hasTooltip = true;
          tooltipContent = matchedEntry[0].Name;
        }
      }
    }

    const isInError = this.props.validationInfo && this.props.validationInfo.errors && this.props.validationInfo.errors.hasOwnProperty(this.props.fieldInfo.name);
    let isRelatedIrwinID = false;

    let isLatLong = (this.props.fieldInfo.name === "x" || this.props.fieldInfo.name === "y")

    let fieldVal = null;
    try
      {
        fieldVal = this.props.attributes[this.props.fieldInfo.name];
      }

      catch (err)
      {
        console.log("No fieldVal found in DetailRow: " + this.props.fieldInfo.name)
      }

    if (isLatLong && fieldVal !== null)
    {
      var latLongNum = parseFloat(fieldVal);
      fieldVal = latLongNum.toFixed(6);
    }

    let domainVal = null;
    let fieldAlias = getFieldAliasOverrides(this.props.fieldInfo);

    //Hack for Certified Date, which doesn't exist
    if (this.props.fieldInfo.name === originFields.modifiedDate && originFields.certifiedField === "CERTIFIED")
    {
      fieldAlias = "Certified Date";
    }

    if (this.props.fieldInfo.name === originFields.relatedIrwinIds)
    {
      isRelatedIrwinID = true;
      fieldAlias = (this.props.attributes[originFields.relatedIrwinIds] && this.props.attributes[originFields.relatedIrwinIds].includes(",")) ? "Related Irwin IDs" : "Related Irwin ID"
    }

    let isDoubleDate = originFields.dateFieldsWithTypeDouble.includes(this.props.fieldInfo.name);

    let fieldType = this.props.fieldInfo.type;
    if (this.props.fieldInfo.domain)
    {
      fieldType = "select";
      const matchingCodedValues = this.props.fieldInfo.domain.codedValues.filter(cv => {return cv.code === fieldVal });
      domainVal = (matchingCodedValues && matchingCodedValues.length === 1) ? matchingCodedValues[0].name : fieldVal;
    }
    let fieldNode;

    if ((this.props.mode === "read" || this.props.isStatic) && !isRelatedIrwinID) 
    {
      switch (fieldType) {
        case "date":
        case "esriFieldTypeDate":
          fieldNode = (
            <span>{fieldVal ? moment(fieldVal).format(this.props.appConfig.timeDateFormat) : "––"}</span>
          )
          break;
        case "bool":
          fieldNode = (
            <span>{fieldVal ? "True" : "False"}</span>
          )
          break;
        case "select":
          fieldNode =  (this.props.fieldInfo.name === originFields.predominantFuelModel) ? (<span>{fieldVal === null ? "––" : fieldVal }</span>) : (<span>{domainVal === null ? "––" : domainVal }</span>);
          break;
        default:
          if (hasTooltip && this.props.mode === "read") 
          {
            fieldNode = (<span style={{wordBreak: 'break-word'}}>{fieldVal}<Tooltip title={tooltipContent} arrow placement="right-start"><span style={{ marginLeft: "15px", verticalAlign: "bottom"  }}><HelpIcon fontSize="small" color="primary" style={{ verticalAlign: "bottom" }} /></span></Tooltip></span>);
          } 
            else 
          {
            fieldNode = (isDoubleDate) ? (<span>{fieldVal ? moment(fieldVal).format(this.props.appConfig.timeDateFormat) : "––"}</span>) : (<span style={{wordBreak: 'break-word'}}>{fieldVal === null ? "––" : fieldVal }</span>)
          }
      }
    }
    else
    {
      if (fieldType === "integer" || fieldType === "small-integer" || (fieldType === "double" && !isDoubleDate))
      {
         const shouldOverrideIncidentSizeToZero = (this.props.fieldInfo.name === "IncidentSize" && fieldVal === null && !this.props.canPerformADSWrite) ? true : false;

         let isAcreage = isAcreageField(this.props.fieldInfo.name);
         let acreNode = (isAcreage && fieldVal !== null && fieldVal > 0 ) ? (' (' + parseFloat(fieldVal).toFixed(2) + ')') : "";
         const defaultValue = (shouldOverrideIncidentSizeToZero) ? 0 : (isAcreage && (fieldVal !== null) && (fieldVal !== 0)) ? parseFloat(fieldVal).toFixed(2) : fieldVal;
         
          fieldNode = (shouldOverrideIncidentSizeToZero) ? <label>0</label> : ( (this.props.canPerformADSWrite && this.props.fieldInfo.name === originFields.calculatedAcres) ?
          (
                <label>{this.state.calculatedAcresValue}</label>
          )
          :
          (
              <Fragment>
                <TextField
                key={this.props.fieldInfo.name}
                name={this.props.fieldInfo.name}
                fullWidth={true}
                defaultValue={defaultValue}
                type="number"
                step={(fieldType === "double" && !isDoubleDate) ? '0.01' : '1'}
                min="0"
                errorText={(isInError) ? this.props.validationInfo.errors[this.props.fieldInfo.name] :""}
                onChange={(event, value) => {
                  const num = parseFloat(value)
                  this.props.onUpdateProp(this.props.fieldInfo.name, Number.isNaN(num) ? null : num);
                }} />
                <label>{acreNode}</label>
              </Fragment>
            )
          )
      }
      else if (fieldType === "date" || fieldType === "esriFieldTypeDate" || isDoubleDate)
      {
        let dateClearNode =  (isClearableDateField(this.props.fieldInfo.name, this.props.canPerformADSWrite) && ((fieldVal !== null) || this.state.isInvalidLocally)) ?
        (
          <IconButton
            color="inherit"
            style={{position: "relative", float:"right", marginLeft:"auto"}}
            aria-label="close"
            onClick={this.setNullValue}
            >
            <CloseIcon />
          </IconButton>
        )
        : "";
        fieldNode = (
          <Fragment>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>

          <KeyboardDateTimePicker
            ampm={false}
            value={fieldVal}
            disabled={!this.props.canPerformADSWrite}
            onChange={(event, date) => {
              if (event && !isNaN(event.getTime()))
              {
                this.props.onUpdateProp(this.props.fieldInfo.name, event.getTime());
                this.setState({
                  isInvalidLocally: false
                });
              }
              else
              {
                this.setState({
                  isInvalidLocally: true
                });
              }
            }}
            format="MM/dd/yyyy HH:mm"
            />
            </MuiPickersUtilsProvider>
              {dateClearNode}
              {(isInError && this.props.validationInfo.errors.hasOwnProperty(this.props.fieldInfo.name)) &&
              <p className="detail-date-error">{this.props.validationInfo.errors[this.props.fieldInfo.name]}</p>
              }
          </Fragment>
        )

      }
      else if (fieldType === "bool")
      {
        fieldNode = (
          <RadioButtonGroup
            className="detail-row-bool-container"
            name={fieldAlias}
            disabled={!this.props.canPerformADSWrite}
            defaultSelected={fieldVal || false}
            onChange={(event, value) => {
              this.props.onUpdateProp(this.props.fieldInfo.name, value);
            }} >
            <RadioButton
              value={true}
              label="True" />
            <RadioButton
              value={false}
              label="False" />
          </RadioButtonGroup>
        )
      }
      else if (fieldType === "select")
      {
        let closeIcon = "";
        if (this.props.canPerformADSWrite && this.dropdownFieldIsNullable(this.props.fieldInfo.name) && (fieldVal !== null))
        {
          closeIcon = (
            <IconButton
              color="inherit"
              style={{position: "relative", float:"right", marginLeft:"auto"}}
              aria-label="close"
              onClick={this.setNullValue}
              >
              <CloseIcon />
            </IconButton>
          )
        }

        fieldNode = (
          <Fragment>
          <SelectField
            fullWidth={true}
            autoWidth={true}
            disabled={!this.props.canPerformADSWrite}
            value={fieldVal}
            errorText={(isInError) ? this.props.validationInfo.errors[this.props.fieldInfo.name] : ""}
            onChange={(event, index, value) => {
              this.props.onUpdateProp(this.props.fieldInfo.name, value);
            }} >
            {this.getFieldValues(this.props.fieldInfo.name, this.props.fieldInfo.domain.codedValues, this.props.isDependent, this.props.dependentAttribute, fieldVal)}
          </SelectField>
          {closeIcon}
			  </Fragment>
        )
      }
      else
      {
        // "string", "guid"
        if (isRelatedIrwinID) 
        {
              fieldNode = (
                <IrwinIdTextField irwinId={this.props.attributes[originFields.relatedIrwinIds]} />
              )
        } 
        else 
        {
        let narrativeIcon = "";
        if (this.props.canPerformADSWrite && this.props.fieldInfo.name === originFields.report)
        {
          narrativeIcon = (
            <Fragment>
            <IconButton
              color="inherit"
              style={{position: "relative", float:"right", marginLeft:"auto"}}
              aria-label="close"
              onClick={this.showNarrativePopup}
              >
              <CallMadeIcon />
            </IconButton>
            <NarrativeDialog
              open={this.state.narrativeDialogOpen}
              onClose={this.onNarrativeDialogClose}
              defaultValue={this.state.narrativeValue}
              onChange={(event, value) => {
                this.setState({
                  narrativeValue: value
                });
                this.props.onUpdateProp(this.props.fieldInfo.name, (value) ? value : null);
              }}
            />
            </Fragment>
          );

          fieldNode = (
            <Fragment>
            <TextField
              name={this.props.fieldInfo.name}
              multiLine={true}
              disabled={!this.props.canPerformADSWrite}
              value={this.state.narrativeValue}
              rowsMax={10}
              errorText={(isInError) ? this.props.validationInfo.errors[this.props.fieldInfo.name] : ""}
              onChange={(event, value) => {
                this.setState({
                  narrativeValue: value
                });
                this.props.onUpdateProp(this.props.fieldInfo.name, (value) ? value : null);
              }} />
              {narrativeIcon}
              </Fragment>
          );
        }
        else
        {
          let unitValidatorBlock = "";
          if (this.props.showUnitValidator)
          {
            unitValidatorBlock = (
              <UnitValidator
              unit={fieldVal}
              onValidated={this.onUnitValidated}
              />
            );
          }

        fieldNode = (this.props.fieldInfo.name === originFields.pooProtectingUnit || this.props.fieldInfo.name === originFields.pooJurisdictionalUnit) ?
         (<Fragment>
          <CoreTextField
            name={this.props.fieldInfo.name}
            fullWidth={true}
            inputProps={{style: {textTransform: 'uppercase'}}}
            disabled={!this.props.canPerformADSWrite}
            defaultValue={fieldVal}
            error={(isInError) ? this.props.validationInfo.errors.hasOwnProperty(this.props.fieldInfo.name) : ""}
            helperText={(isInError) ? this.props.validationInfo.errors[this.props.fieldInfo.name] : ""}
            onChange={(event) => {
              this.props.onUpdateProp(this.props.fieldInfo.name, (event.target.value) ? event.target.value : null);
            }} />
            {unitValidatorBlock}
            </Fragment>
        )
        :
         (
            <TextField
              name={this.props.fieldInfo.name}
              multiLine={true}
              disabled={!this.props.canPerformADSWrite}
              defaultValue={fieldVal}
              errorText={(isInError) ? this.props.validationInfo.errors[this.props.fieldInfo.name] : ""}
              onChange={(event, value) => {
                this.props.onUpdateProp(this.props.fieldInfo.name, (value) ? value : null);
              }} />
          )
      }
     }
    }
} 
    
    const label =  (isInError)
    ? <label className="detail-row-label detail-row-error-label">{fieldAlias}</label>
    : ( (this.props.isRequired) ?
        (<label className="detail-row-label detail-row-required"><span>{fieldAlias}<span className="required-symbol">*</span></span></label>)
        :
        (<label className="detail-row-label">{fieldAlias}</label>)
     );

    const derivableLink = (this.props.isDerivable && this.props.mode !== "read")
    ?
    (
      (this.props.isDeriving) ?
        <CircularProgress size={14} thickness={3} color={theme.palette.primary1Color} />
        :
        <Button size="small" color="primary" disabled={!this.props.canPerformADSWrite} onClick={e => {this.props.onDeriveValue(this.props.fieldInfo.name)} }>Derive</Button>
    )
    : '';

    let highlightFieldClass = "";
    if (this.props.highlightRequiredFields && (fieldVal === undefined || fieldVal === null)) {
      highlightFieldClass = " detail-row-highlight-field"
    }

    return (
      <div className={"detail-row" + highlightFieldClass}>
        {label}
        <div className="detail-row-value">
          {fieldNode}
        </div>
        {derivableLink}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  appConfig: state.config
})

export default connect(mapStateToProps)(DetailRow)
